import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
};

export const messagesEN: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    optIn: 'By checking this box and clicking "Verify my student status," you consent to the use of your information for verification purposes only. Your information will be transferred to the United States and will be treated according to SheerID\'s <a class="sid-link" target="_blank" href="https://www.sheerid.com/privacy_notice_services/">privacy policy</a>. SheerID will not sell, rent, or use your information for marketing purposes. Don\'t worry, SheerID will only use documentation for verification purposes and after verification the doc will be deleted. To exercise your right regarding your personal data, please follow this <a href="https://www.sheerid.com/privacy_notice_services/" target="_blank" class="sid-link">link<a>.',
    howDoesVerifyingWork: 'How does verifying work?',
    schoolName: 'University / College name',
    schoolNamePlaceholder: 'University / College name',
    firstNamePlaceholder: 'First name',
    lastNamePlaceholder: 'Last name',
    emailAddressPlaceholder: 'Email address',
    countryPlaceholder: 'Country',
    copied: 'Copied',
    step: {
        pending: {
            subtitle2: ' ',
        },
        success: {
            title: 'Success! You\'ve been verified.',
            subtitle: 'Here is your personal coupon code. It is unique to you and can only be used once.',
            verificationOnly: 'SheerID handles verification only. Now that you\'ve been approved, please direct all questions about the promotion terms and/or code use to Back Market customer service.',
            redirectButtonText: 'Continue to Back Market',
            emailNotification: 'We have emailed you a copy so you can use your new code now or later. Look for the email from verify@sheerid.com.',
        },
        personalInfo: {
            title: 'Unlock this Student-Only Offer',
            howDoesVerifyingWorkDetails: 'To be eligible for this offer, you must currently be enrolled in a degree-granting, accredited school of higher education.<br><br>Back Market uses SheerID, a trusted partner, to verify that you are a current student. SheerID only collects information that assists in verifying your eligibility. Additional information or documentation may be requested.',
        },
        docUpload: {
            title: 'We need more information',
            subtitle: 'Documents will be reviewed in {estReviewTime} by staff at SheerID, a trusted partner.',
            howDoesVerifyingWorkDetails: 'Document review is handled by SheerID, a trusted partner who specializes in verifying students.<br><br> Documents are used only for verifying your student status is current and will be permanently deleted after review is finalized. They will not be shared with Back Market.',
            uploadInstructions: 'Upload your school-issued document that shows:',
        },
    },
};
